import { useEffect } from 'react'
import { useBoardStore } from '../../state/board-store.js'
import styles from './BoardVersionPicker.module.css'

/** Historical snapshots are read-only; the live board remains the editable selection. */
export function BoardVersionPicker() {
  const boardId = useBoardStore((state) => state.activeBoardId)
  const viewed = useBoardStore((state) => state.viewedVersion)
  const versions = useBoardStore((state) => state.versions)
  const loading = useBoardStore((state) => state.versionsLoading)
  const refresh = useBoardStore((state) => state.refreshVersions)
  const view = useBoardStore((state) => state.viewVersion)

  useEffect(() => {
    if (boardId) void refresh()
  }, [boardId, refresh])

  if (!boardId) return null
  return (
    <label className={styles.picker}>
      <span>Version</span>
      <select
        aria-label="Board version"
        value={viewed?.revision ?? 'current'}
        disabled={loading && versions.length === 0}
        onFocus={() => void refresh()}
        onChange={(event) => void view(event.target.value === 'current' ? null : Number(event.target.value))}
      >
        <option value="current">Current (editable)</option>
        {versions.map((version) => (
          <option key={version.revision} value={version.revision}>
            Revision {version.revision} · {version.source === 'ai'
              ? `AI change${version.integrationName ? ` (${version.integrationName})` : ''}`
              : 'Before AI change'}
          </option>
        ))}
      </select>
    </label>
  )
}
